<template>

    <div class="relation666">
        <van-row>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(3790)">
                    <img src="https://cdn.edstatic.com/203012120000/00e274e187154a0addf47c23fa314750/2026/02/8f6a9b08-168e-4403-be95-0933c13ee91c.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(3745)">
                    <img src="https://cdn.edstatic.com/203012120000/c65bef6eb2d62a27a45ec8fb3974dc25/2026/02/735e850d-54f5-44fd-9dbd-889a7c39c7cd.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(3794)">
                    <img src="https://cdn.edstatic.com/203012120000/9bd48b08cda1a9944682d3b6e1a3e1da/2026/02/f9d3c9b7-974e-4df0-81fc-3dd361f92c6c.png"
                        alt="">
                </a>
            </van-col>
        </van-row>
        <van-row>
            <van-col span="16">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(3746)">
                    <img src="https://cdn.edstatic.com/203012120000/2562257cc51a07de4ec46c9fae41c207/2026/02/367e9846-2da6-4359-86df-1ea68e905465.png"
                        alt="">
                </a>
                <a href="Javascript:void(0)" title="picname" @click="skipLink(3748)">
                    <img src="https://cdn.edstatic.com/203012120000/65640ee2c9733cd1135d967a74f232a0/2026/02/692dc6ca-d766-49c5-9839-df1d8524fec7.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(3747)">
                    <img src="https://cdn.edstatic.com/203012120000/e6605b1f7743abe1024d7bf90ae91fa2/2026/02/a63d3101-e8f0-414b-8469-40f97d1d2cd4.png"
                        alt="">
                </a>
                <a href="Javascript:void(0)" title="picname" @click="skipLink(3475)">
                    <img src="https://cdn.edstatic.com/203012120000/d694ea6e2edd0a0be7ff559eb82e0ef8/2026/02/972cf205-2c89-4e1e-ab66-65e5ba964247.png"
                        alt="">
                </a>
            </van-col>
        </van-row>
        <van-row>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(3792)">
                    <img src="https://cdn.edstatic.com/203012120000/86ed11fc84b55a1708bc7aa50257d9fb/2026/02/bcc56dd2-577c-4380-80f3-82794746b41d.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(3793)">
                    <img src="https://cdn.edstatic.com/203012120000/c32cba4da2288a494cdd2830a43b9f8d/2026/02/98f417f7-35a3-4140-ae81-8041feac4c92.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(3749)">
                    <img src="https://cdn.edstatic.com/203012120000/02b979dbcaa9ea62f513c42bf5753db6/2026/02/453ef644-475a-4404-a67d-5e1fd5c1cbc7.png"
                        alt="">
                </a>
            </van-col>
        </van-row>
    </div>

</template>
<script>
export default {
    props: {
        meetingButton: Array,
        showButtonText: Number,

    },
    data() {
        return {
            button_rows: 3,
        }
    },
    methods: { // 将 skipLink 方法移至此处
        skipLink(id) {
            let item=null;
            for(var i=0;i<this.meetingButton.length;i++){
                if(this.meetingButton[i].id==id){
                    item=this.meetingButton[i];
                    break;
                }
            }
            console.log(item);
            if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
                ImagePreview({
                    images: [item.url],
                    closeable: true,
                    showIndex: false
                });
            } else {
                window.localStorage.removeItem('callback_url');
                window.localStorage.setItem('callback_url', item.url);
                window.location.href = item.url;

                if (item.url.indexOf('vascularnews/meeting/schedule') > -1 && window.localStorage.getItem('schedule_date')) {
                    window.localStorage.removeItem('schedule_date');
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.relation666 {
    // overflow: auto;
    padding: 0.1rem 0.5rem;
    @include flex(row);
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    background: #f9f8f8;

    .van-row {
        width: 100%;
        line-height: 0;

    }

    .van-col {
        line-height: 0;
    }

    div {
        text-align: center;
    }

    a {
        display: inline-block;
        text-align: center;
        line-height: 0;
        padding: 0.17rem;
        // margin-bottom: 16px;
    }

    img {
        width: 100%;
        height: 100%;

    }
}


.one-column {
    flex-direction: column;
    align-items: flex-start;
}



@media screen and (min-width: 500px) {
    .relation666 a {
        padding: 0.29rem !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Meeting/Button666.vue